<!-- Desktop -->
<div class="toolbar__controls" *ngIf="isDesktop">
  <app-donation-button class="toolbar__button" *ngIf="isDonateAvailable"></app-donation-button>
  <mzima-client-button
    (buttonClick)="openShare()"
    color="secondary"
    class="toolbar__button"
    [data-qa]="'share'"
  >
    <span>{{ 'app.share' | translate }}</span>
    <mat-icon icon svgIcon="share"></mat-icon>
  </mzima-client-button>
</div>

<!-- Smaller screens -->
<ng-container *ngIf="!isDesktop">
  <div class="menu__footer-container">
    <div class="menu__footer">
      <div class="logo-container">
        <a href="https://arsenaldemocracy.org" target="_blank"
          ><img src="../../../../../assets/images/project-of-arsenal.svg"
        /></a>
      </div>
      <app-donation-button
        class="menu__footer__button"
        *ngIf="isDonateAvailable"
      ></app-donation-button>
      <mzima-client-button
        *ngIf="canAccessSettings"
        (buttonClick)="openSettings()"
        fill="clear"
        color="transparent-style-1"
      >
        <span class="settings-label">
          <mat-icon icon svgIcon="settings" class="settings-icon"></mat-icon>
          {{ 'nav.settings' | translate }}
        </span>
      </mzima-client-button>
      <mzima-client-button
        class="donate-btn"
        type="button"
        target="_blank"
        href="https://secure.actblue.com/donate/resistmap?refcode=website-footer"
        fill="outline"
        color="transparent-style-1"
      >
        {{ 'app.donate' | translate }}
      </mzima-client-button>
      <mzima-client-button
        class="about-btn"
        type="button"
        fill="outline"
        color="transparent-style-1"
        (buttonClick)="openAboutModal()"
      >
        {{ 'nav.about' | translate }}
      </mzima-client-button>
      <mzima-client-button
        fill="outline"
        color="transparent-style-1"
        (buttonClick)="openShare()"
        class="menu__footer__button"
      >
        {{ 'app.share' | translate }}
        <mat-icon icon svgIcon="share"></mat-icon>
      </mzima-client-button>
      <app-footer></app-footer>
    </div>
  </div>
</ng-container>
